(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["progress"] = factory();
	else
		root["rich"] = root["rich"] || {}, root["rich"]["progress"] = factory();
})(typeof self !== 'undefined' ? self : this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "./";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 461);
/******/ })
/************************************************************************/
/******/ ({

/***/ 461:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, exports, __webpack_require__(462)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(module, exports, require('../../components/progress/progress'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod, mod.exports, global.progress);
    global.index = mod.exports;
  }
})(this, function (module, exports, _progress) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _progress2 = _interopRequireDefault(_progress);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  _progress2.default.install = function (Vue) {
    Vue.component(_progress2.default.name, _progress2.default);
  };

  exports.default = _progress2.default;
  module.exports = exports['default'];
});

/***/ }),

/***/ 462:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(463)
}
var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(464),
  /* template */
  __webpack_require__(465),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 463:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 464:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(module, exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod, mod.exports);
    global.progress = mod.exports;
  }
})(this, function (module, exports) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });


  var COMPONENT_NAME = 'rich-progress';
  var DIRECTION_H = 'horizontal';
  var DIRECTION_V = 'vertical';

  exports.default = {
    name: COMPONENT_NAME,
    props: {
      value: {
        type: Number,
        default: 0,
        validator: function validator(value) {
          return value >= 0 && value <= 100;
        }
      },

      isSubsection: false,
      direction: {
        type: String,
        default: DIRECTION_H,
        validator: function validator(val) {
          return val === DIRECTION_H || val === DIRECTION_V;
        }
      },
      params: {
        type: Array,
        default: function _default() {
          return [];
        },
        validator: function validator(val) {
          var flag = true;

          var res = val.map(function (e) {
            return e.value;
          }).filter(function (e) {
            return e !== undefined;
          });
          if (res.length && res.length !== val.length) flag = false;else if (res.length) {
            var num = res[0];
            for (var i = 1; i < res.length; i++) {
              if (num >= res[i]) {
                flag = false;
                break;
              }
              num = res[i];
            }
          }
          return flag;
        }
      },

      current: {
        type: Number,
        default: 0
      },
      content: {
        type: Object,
        default: function _default() {
          return {};
        }
      }
    },
    data: function data() {
      return {
        config: this.params,
        per: 0,
        pos: 0,
        lastTextOverflow: 0,
        scrollInfo: { showLeft: false, showRight: false, offset: 0 }
      };
    },

    computed: {
      findProgress: function findProgress() {
        var inProgress = 0;
        if (this.direction === DIRECTION_H) inProgress = null;
        this.config && this.config.forEach(function (item, i) {
          if (item.inProgress) {
            inProgress = i;
          }
        });
        return inProgress;
      }
    },
    mounted: function mounted() {
      var isSubsection = this.isSubsection,
          direction = this.direction;

      if (isSubsection && direction === DIRECTION_H) {
        this.$refs.scrollPanel && this.$refs.scrollPanel.addEventListener('scroll', this.handleScroll);

        var topOverflow = ((this.$refs.subtitle && this.$refs.subtitle.pop().clientWidth) - 20) / 2;
        var bottomOverflow = ((this.$refs.maintitle && this.$refs.maintitle.pop().clientWidth) - 20) / 2;
        this.lastTextOverflow = Math.max(topOverflow, bottomOverflow);
        var realWidth = this.params.length * 78 + this.lastTextOverflow - 2;
        if (realWidth > this.$refs.scrollPanel.clientWidth) this.scrollInfo.showRight = true;
      }
    },
    destroyed: function destroyed() {
      var isSubsection = this.isSubsection,
          direction = this.direction;

      if (isSubsection && direction === DIRECTION_H) {
        this.$refs.scrollPanel && this.$refs.scrollPanel.removeEventListener('scroll', this.handleScroll);
      }
    },

    watch: {
      params: {
        deep: true,
        immediate: true,
        handler: function handler() {
          this.initCalcProgress();
        }
      }
    },
    methods: {
      initCalcProgress: function initCalcProgress() {
        var isSubsection = this.isSubsection,
            direction = this.direction;

        if (isSubsection && direction === DIRECTION_H) {
          this.calcProgress();
        }
      },
      getPosition: function getPosition() {
        var _$refs = this.$refs,
            currLine = _$refs.currLine,
            currDot = _$refs.currDot,
            group = _$refs.group;

        var pos = 0;
        if (currLine && currLine[0]) {
          pos = this.getOffset(currLine[0], group) + currLine[0].clientWidth;
        } else if (currDot && currDot[0]) {
          pos = this.getOffset(currDot[0], group);
        }
        var offset = this.scrollInfo.offset;

        return pos - offset - 1;
      },
      getOffset: function getOffset(target, parent) {
        var num = target.offsetLeft || 0;
        if (target.offsetParent && target.offsetParent !== parent) {
          num = target.offsetLeft + this.getOffset(target.offsetParent, parent);
        }
        return num;
      },
      handleScroll: function handleScroll(e) {
        var ele = e.target || e.srcElement;
        var num = ele.scrollLeft;
        var realWidth = this.params.length * 78 + this.lastTextOverflow - 2;

        this.scrollInfo = { showLeft: num > 0, showRight: realWidth > ele.clientWidth && num + ele.clientWidth <= realWidth, offset: num };
        this.$emit('scroll');
      },
      calcProgress: function calcProgress() {
        var params = this.params,
            current = this.current;

        var list = params.map(function (e, i) {
          var mainTitle = e.mainTitle,
              detail = e.detail,
              value = e.value;

          return { mainTitle: mainTitle, detail: detail, value: value || i + 1 };
        });
        var vals = list.map(function (e) {
          return e.value;
        });
        var flag = false;
        for (var i = vals.length; i >= 0; i--) {
          if (current >= vals[i]) {
            if (current === vals[i] || i === vals.length - 1) list[i].isLight = true;
            list[i].inProgress = true;
            flag = true;
            if (i !== vals.length - 1) {
              this.per = ((current - vals[i]) / (vals[i + 1] - vals[i]) * 100).toFixed(2);
            }
            break;
          }
        }
        if (current && !flag) {
          this.per = (current / vals[0] * 100).toFixed(2);
        }
        this.config = list;
      },
      getProgress: function getProgress(v, i) {
        var findProgress = this.findProgress,
            per = this.per;

        if (i === 0 && findProgress === null || findProgress !== null && findProgress + 1 === i) {
          return per;
        }
        if (findProgress >= i) return 100;
        return 0;
      },
      getItemStyle: function getItemStyle(isLight) {
        var params = this.params;

        var len = params.length || 1;
        var subWidth = 'calc(' + (100 / len).toFixed(4) + '% - ' + Math.ceil(this.lastTextOverflow / len) + 'px)';
        return [{ width: subWidth, minWidth: '78px' }];
      }
    }
  };
  module.exports = exports['default'];
});

/***/ }),

/***/ 465:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.direction === 'horizontal' && !_vm.isSubsection) ? _c('div', {
    staticClass: "rich-progress"
  }, [_vm._t("start"), _vm._v(" "), _c('div', {
    staticClass: "rich-progress-content"
  }, [_c('div', {
    staticClass: "rich-progress-bg"
  }), _vm._v(" "), _c('div', {
    staticClass: "rich-progress-progress",
    style: ([{
      width: _vm.value + '%'
    }])
  })]), _vm._v(" "), _c('p', {
    staticClass: "rich-progress-end"
  }, [_vm._t("end")], 2)], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "rich-progress rich-progress-horizontal"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.scrollInfo.showLeft),
      expression: "scrollInfo.showLeft"
    }],
    staticClass: "rich-progress-scroll-shadow left"
  }, [_vm._t("scroll-start")], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.scrollInfo.showRight),
      expression: "scrollInfo.showRight"
    }],
    staticClass: "rich-progress-scroll-shadow right"
  }, [_vm._t("scroll-end")], 2), _vm._v(" "), _c('div', {
    ref: "scrollPanel",
    staticClass: "scroll-panel"
  }, [(_vm.direction === 'horizontal' && _vm.isSubsection) ? _c('ul', {
    ref: "group",
    staticClass: "rich-progress-group"
  }, [_c('div', {
    staticClass: "group-tip",
    style: (_vm.getItemStyle(false))
  }, [_c('p', {
    staticClass: "top"
  }, [_vm._v(_vm._s(_vm.content.top))]), _vm._v(" "), _c('p', {
    staticClass: "bottom"
  }, [_vm._v(_vm._s(_vm.content.bottom))])]), _vm._v(" "), _vm._l((_vm.config), function(v, i) {
    return _c('li', {
      key: i,
      staticClass: "rich-progress-item",
      class: {
        'item-box-light': v.isLight, 'item-box-finish': _vm.current > v.value, 'item-box-wait': _vm.current < v.value
      },
      style: (_vm.getItemStyle(v.isLight))
    }, [_c('div', {
      staticClass: "item-box"
    }, [_c('div', {
      staticClass: "line",
      style: ([{
        width: "calc(100% - 20px)"
      }])
    }, [_c('p', {
      ref: (_vm.getProgress(v, i) > 0 && _vm.getProgress(v, i) < 100) ? 'currLine' : '',
      refInFor: true,
      staticClass: "line-bar",
      style: ([{
        width: ((_vm.getProgress(v, i)) + "%")
      }])
    })]), _vm._v(" "), _c('div', {
      staticClass: "main-content"
    }, [_c('p', {
      ref: "subtitle",
      refInFor: true,
      staticClass: "subtitle"
    }, [_vm._v(_vm._s(v.detail))]), _vm._v(" "), _c('p', {
      ref: v.isLight ? 'currDot' : '',
      refInFor: true,
      staticClass: "horizontal-dot-bg dot-bg"
    }, [_c('span', {
      staticClass: "dot"
    })]), _vm._v(" "), _c('p', {
      ref: "maintitle",
      refInFor: true,
      staticClass: "main-title"
    }, [_vm._v(_vm._s(v.mainTitle ? v.mainTitle : i + 1))])])])])
  })], 2) : _vm._e(), _vm._v(" "), _vm._t("content")], 2)]), _vm._v(" "), (_vm.direction === 'vertical') ? _c('div', {
    staticClass: "rich-progress"
  }, [_c('ul', {
    staticClass: "rich-progress-group"
  }, _vm._l((_vm.config), function(v, i) {
    return _c('li', {
      key: i,
      staticClass: "rich-progress-item",
      class: {
        'item-box-light': v.inProgress, 'item-box-no-light': _vm.findProgress < i
      }
    }, [_c('div', {
      staticClass: "item-box"
    }, [_c('p', {
      staticClass: "vertical-dot-bg dot-bg",
      style: ({
        'background-color': ("" + (v.background))
      })
    }, [_c('span', {
      staticClass: "dot",
      style: ({
        'background-color': ("" + (v.color))
      })
    })]), _vm._v(" "), _c('div', {
      staticClass: "main-content"
    }, [_c('p', {
      staticClass: "line",
      style: ({
        'background-color': ("" + (_vm.config[i + 1] && _vm.config[i + 1].color))
      })
    }), _vm._v(" "), _c('p', {
      staticClass: "text-content"
    }, [_c('span', {
      staticClass: "main-title",
      style: ({
        'color': v.color
      })
    }, [_vm._v(_vm._s(v.mainTitle))]), _vm._v(" "), _c('span', {
      staticClass: "subtitle",
      style: ({
        'color': v.color
      })
    }, [_vm._v(_vm._s(v.detail))])])])])])
  }), 0)]) : _vm._e()])
},staticRenderFns: []}

/***/ }),

/***/ 6:
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// this module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate
    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ })

/******/ });
});